import React from 'react';

import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

export default function MoveHandle({ className, dragHandleProps }) {
  return <span {...dragHandleProps} title={StringConstantsMixin.strings.MOVE} className={`${styles.move} item-move clickable ${className}`} />;
}
